<template>
  <div>
    <div class="modalWrap">
      <h1 class="modalHeader">공유하기</h1>
      <button class="close" @click="close">닫기</button>

      <ul class="snsBtns">
        <li>
          <button class="kakao" @click="shareKakao">
            <img src="../../assets/img/ico/sns_share_kakao.png" alt="" />
            카카오톡
          </button>
        </li>

        <li>
          <button class="kakao" @click="shareNaver">
            <img src="../../assets/img/ico/sns_share_naver.png" alt="" />
            네이버
          </button>
        </li>
      </ul>

      <div class="copyBox">
        <input type="text" class="urlStr" ref="urlStr" v-model="this.eventLink" readonly />
        <button class="urlCopy" @click="urlCopy">
          URL복사
        </button>
      </div>
    </div>

    <div class="darkFilter"></div>
  </div>
</template>

<script>

export default {
  props: ['eventTitle', 'eventDescription', 'eventImage', 'eventLink'],
  data () {
    return {
    }
  },
  name:'shareSns', 
  methods: {
    close () {
      this.$emit('close')
    },

    // 카카오톡 링크 공유
    shareKakao () {
      let kakaoLinkObj = {
        objectType: 'feed',
        content: {
          title: this.eventTitle,
          description: this.eventDescription,
          imageUrl: this.eventImage,
          imageWidth: 800,
          imageHeight: 400,
          link: {
            mobileWebUrl: this.eventLink,
            webUrl: this.eventLink
          }
        },
        buttons: [
          {
            title: window.ENV.$SERVICE_NAME_KO + '로 이동',
            link: {
              mobileWebUrl: this.eventLink,
              webUrl: this.eventLink
            }
          }
        ],
        installTalk: true
      }

      Kakao.Link.sendDefault(kakaoLinkObj)

    },

    // 네이버 링크 공유
    shareNaver () {
      var url = encodeURI(encodeURIComponent(this.eventLink));
      var title = encodeURI(this.eventTitle);
      var shareURL = "https://share.naver.com/web/shareView.nhn?url=" + url + "&title=" + title;

      window.open(shareURL, '_share')
    },

    // url 복사 함수
    urlCopy() {
      let t = this.$refs.urlStr
      t.select()
      t.setSelectionRange(0, 99999)
      document.execCommand('copy')
      document.getSelection().removeAllRanges()

      this.$emit('copy')
    }
  }
}
</script>

<style lang="scss" scoped>
.modalWrap {
  position: fixed;
  top: 50%;
  left: 10%;
  z-index: 130;
  width: 80%;
  padding:0 0 15px 0;
  background-color: #fff;
  border-radius:8px;
  text-align: center;
  box-sizing: border-box;
  box-shadow: 0 3px 5px 1px rgb(0, 0, 0, 0.2);
  transform:translateY(-50%);
  transition: all 0.3s ease-in-out;

  .modalHeader {
    height:50px;
    padding-top: 0;
    font-size: 16px;
    border-radius:8px;
    background:#eee;
    line-height:48px;
  }

  .close{
    position:absolute;
    top:11px;
    right:15px;
    z-index:3;
    display:block;
    width:30px;
    height:30px;
    color:transparent;
    background:url('../../assets/img/ico/ico_times_black.png') 50% 50% / 14px auto no-repeat;
  }

  .snsBtns {
    margin-top:20px;
    font-size:0;

    li {
      display:inline-block;
      margin:0 5px;
      vertical-align: middle;

      button {
        font-size:12px;
        color:#535353;
        img {
          display:block;
          width:60px;
          height:auto;
          margin:0 auto;
        }
      }
    }
  }

  .copyBox {
    overflow: hidden;
    width:100%;
    margin-top:30px;
    padding:0 15px;
    box-sizing: border-box;

    .urlStr {
      float:left;
      width:calc(100% - 70px);
      height:33px;
      padding:0 10px;
      border:1px solid #aaa;
      border-radius: 4px 0 0 4px;
      box-sizing: border-box;
      font-size:12px;
      color:#4a90e2;
    }

    .urlCopy{
      float:left;
      display:block;
      width:70px;
      height:33px;
      color:#fff;
      font-size:12px;
      border-radius:0px 4px 4px 0;
      background:#535353;
    }
  }

}
.darkFilter {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 115;
  background-color: black;
  opacity: 0.5;
  width: 100%;
  height: 100%;
}
</style>